import { useCallback, useState } from 'react'

import type { TripListFilterSection } from './TripListFiltersModal'

interface TripListFiltersModalState {
  filtersModalOpen: boolean
  /** Section the modal was opened from, or undefined when opened via "All filters". */
  focusedSection?: TripListFilterSection
  openAllFilters: () => void
  openDateFilters: () => void
  openLocationFilters: () => void
  openTypeFilters: () => void
  openStatusFilters: () => void
  closeFiltersModal: () => void
  setFiltersModalOpen: (open: boolean) => void
}

/**
 * Open/close state for the trip planner list view filters modal, shared by the
 * desktop and mobile list views so both open the same modal from their chips.
 */
export function useTripListFiltersModal(): TripListFiltersModalState {
  const [filtersModalOpen, setFiltersModalOpen] = useState(false)
  const [focusedSection, setFocusedSection] = useState<TripListFilterSection | undefined>()

  const openAllFilters = useCallback(() => {
    setFocusedSection(undefined)
    setFiltersModalOpen(true)
  }, [])

  const openDateFilters = useCallback(() => {
    setFocusedSection('date')
    setFiltersModalOpen(true)
  }, [])

  const openLocationFilters = useCallback(() => {
    setFocusedSection('location')
    setFiltersModalOpen(true)
  }, [])

  const openTypeFilters = useCallback(() => {
    setFocusedSection('type')
    setFiltersModalOpen(true)
  }, [])

  const openStatusFilters = useCallback(() => {
    setFocusedSection('status')
    setFiltersModalOpen(true)
  }, [])

  const closeFiltersModal = useCallback(() => {
    setFiltersModalOpen(false)
  }, [])

  return {
    filtersModalOpen,
    focusedSection,
    openAllFilters,
    openDateFilters,
    openLocationFilters,
    openTypeFilters,
    openStatusFilters,
    closeFiltersModal,
    setFiltersModalOpen,
  }
}
